import { Link } from 'react-router-dom';
import { LogoProps } from '../types/global';

export default function Logo({ src, alt }: Readonly<LogoProps>) {
  if (src === '') {
    return '/pip_green_logo.svg';
  }
  return (
    <div className="flex justify-left align-middle overflow-hidden h-9 w-auto">
      <Link to="/">
        <img src={src} alt={alt} className="max-h-full max-w-full object-contain" />
      </Link>
    </div>
  );
}
